"use client";
import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import { RenderToast, validateNestedParams } from "@/helper/HelperFunction";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import classes from "./ResetPassword.module.css";

const ResetPassword = ({ handleResetPassword, loading }) => {
  const navigate = useNavigate();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");

  const handleValidate = async (e) => {
    e.preventDefault();
    const params = {
      password,
      confirmPassword,
    };
    if (!validateNestedParams(params)) return;

    if (params["password"]?.length < 8) {
      return RenderToast({
        type: "error",
        message: "Password must contain min 8 characters",
      });
    }
    if (params["password"] !== params["confirmPassword"]) {
      return RenderToast({
        type: "error",
        message: "Password and Confirm Password do not match!",
      });
    }
    handleResetPassword(params);
  };

  return (
    <>
      <div className={classes.formContainer}>
        <div className={classes.loginHeadingContainer}>
          <h6 className={classes.loginHeading}>Reset Password</h6>
          <p>Enter your new password.</p>
        </div>
        <form className={classes.loginForm}>
          <Input
            placeholder="Enter Password"
            type="password"
            value={password}
            setter={setPassword}
            label={"Enter New Password"}
          />
          <Input
            placeholder="Enter Password"
            value={confirmPassword}
            setter={setConfirmPassword}
            type="password"
            label={"Confirm Password"}
          />
        </form>
        <Button
          className={classes.loginBtn}
          label={loading ? "Wait..." : "Set Password"}
          onClick={handleValidate}
          disabled={loading}
          type="square"
        />
        <p className={classes.forgetPass}>
          <span onClick={() => navigate("/login")}>Back To Login?</span>
        </p>
      </div>
    </>
  );
};

export default ResetPassword;
